import * as React from 'react'
import createSvgIcon from './createSvgIcon'

export default createSvgIcon(
  <React.Fragment>
    <g clipPath="url(#clip0_1174_1018)">
      <rect
        width="16"
        height="16"
        rx="8"
        transform="matrix(1 0 0 -1 0 16)"
        fill="currentColor"
      />
      <path
        d="M8.02051 4.00098C8.0381 4.00133 8.05568 4.00165 8.07324 4.00293C8.09094 4.00421 8.10854 4.00562 8.12598 4.00781C8.14301 4.00996 8.15983 4.01358 8.17676 4.0166C8.18653 4.01835 8.19638 4.01946 8.20605 4.02148C8.23359 4.02726 8.26102 4.03388 8.28809 4.04199C8.29173 4.04309 8.2952 4.04476 8.29883 4.0459C8.31659 4.05145 8.33407 4.05789 8.35156 4.06445C8.36762 4.07049 8.38376 4.07618 8.39941 4.08301C8.48309 4.11944 8.56261 4.16807 8.63574 4.22852C8.66048 4.24893 8.68438 4.27031 8.70703 4.29297L11.707 7.29297C12.0973 7.68351 12.0975 8.31658 11.707 8.70703C11.3166 9.09746 10.6835 9.09734 10.293 8.70703L9 7.41406V11C9 11.5522 8.55223 11.9999 8 12C7.44772 12 7 11.5523 7 11V7.41406L5.70703 8.70703C5.31658 9.09746 4.6835 9.09734 4.29297 8.70703C3.90245 8.31651 3.90247 7.68349 4.29297 7.29297L7.29297 4.29297C7.33824 4.2477 7.38719 4.20587 7.44043 4.16992C7.493 4.13439 7.54847 4.10452 7.60547 4.08008C7.64937 4.06123 7.69531 4.04665 7.74219 4.03418C7.75876 4.02977 7.77525 4.02503 7.79199 4.02148C7.80296 4.01917 7.8141 4.01758 7.8252 4.01562C7.84271 4.01252 7.8603 4.00998 7.87793 4.00781C7.8957 4.00565 7.9136 4.00415 7.93164 4.00293C7.94758 4.00184 7.96352 4.00131 7.97949 4.00098C7.98628 4.00084 7.99318 4 8 4C8.00686 4 8.01368 4.00084 8.02051 4.00098Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1174_1018">
        <rect
          width="16"
          height="16"
          rx="8"
          transform="matrix(1 0 0 -1 0 16)"
          fill="white"
        />
      </clipPath>
    </defs>
  </React.Fragment>,
  'TrendDownPositiveFlipped'
)
